import React from "react";
import {useTranslation} from "react-i18next";

/**
 * Custom breadcrumb component that lets you add parameters to the breadcrumb link
 */
type BreadcrumbType = {
  url: string;
  urlParams?: string;
  siteName: string;
};

const BreadcrumbsWithParams: React.FC<{breadcrumbs: BreadcrumbType[]}> = ({breadcrumbs}) => {
  const {t} = useTranslation();

  return (
    <section className="breadcrumb">
      <div>
        <div className="breadcrumb__wrapper">
          <ul id="breadcrumb">
            {breadcrumbs.map((crumb, index) => {
              const href = crumb.urlParams ? `${crumb.url}?${crumb.urlParams}` : crumb.url;

              return (
                <li key={index}>
                  <a
                    href={href}
                    title={t("general.open--title", {title: crumb.siteName})}
                    className="breadcrumb-link--path"
                  >
                    <span>{crumb.siteName}</span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default BreadcrumbsWithParams;
